<template>
  <div class="rightData_main-div">
    <p class="dataMain_title-p">添加事件</p>
    <div class="dataMain_body-div">
      <div
        class="dataBody_container-div"
        v-for="(item, index) in list"
        :key="index"
      >
        <!-- 内容 -->
        <div class="page-title-div dataPointClick" @click="editEvent(item)">
          <div class="page-title-div-select">
            <div class="page-title-but">{{ item.userdata.name }}</div>
          </div>
        </div>
        <div class="dataIcon-div">
          <img :src="emptyImg" alt="错误" @click="remove(index)" />
        </div>
      </div>
      <div class="dataBody_btn-div">
        <a-button
          class="dataBtn_style"
          type="dashed"
          icon="plus"
          @click="showAddModal()"
        ></a-button>
      </div>
      <a-button @click="setComponent">保存</a-button>
    </div>
    <!-- 弹窗 -->
    <a-modal
      style="width: 80%"
      width="60%"
      v-model="visible"
      title="新增数据交互"
      :footer="null"
    >
      <!-- 添加弹窗显示内容 -->
      <div v-show="addVisible" class="add_modal-main">
        <!-- header -->
        <div class="addModal_user-div">
          <!-- 新增用户 -->
          <div class="left-div">
            <a-input
              placeholder="输入数据交互名称"
              class="input_style"
              v-model="userData.name"
            />
          </div>
          <!-- 表选择 -->
          <div class="left-div">
            <div class="page-title-div-select">
              <a-select
                style="width: 100%"
                placeholder="请选择表"
                v-model="userData.curd"
              >
                <a-select-option
                  :value="item"
                  v-for="(item, index) in 10"
                  :key="index"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </div>
            <div class="page-title-div-img"></div>
          </div>
          <!--  -->
          <div class="left-div">
            <div class="page-title-div-select">
              <a-select
                style="width: 100%"
                placeholder="请选择交互类型"
                v-model="userData.type"
              >
                <a-select-option
                  :value="item"
                  v-for="(item, index) in 10"
                  :key="index"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </div>
            <div class="page-title-div-img"></div>
          </div>
          <!-- 回调函数 -->
          <div class="left-div">
            <div class="page-title-div-select">
              <a-select
                style="width: 100%"
                placeholder="请选择回调函数"
                v-model="userData.type"
              >
                <a-select-option
                  :value="item"
                  v-for="(item, index) in 10"
                  :key="index"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </div>
            <div class="page-title-div-img"></div>
          </div>
          <!-- 控制图标 -->
          <div class="icon-div">
            <img :src="jsImg" alt="错误" @click="clickJSImg()" />
          </div>
        </div>
        <!-- options -->
        <div class="addModal_options-div">
          <!-- 标题 -->
          <p class="rightData_title-p">字段配置</p>
          <div class="options_body-div">
            <div
              class="options_bodyContainer-div"
              v-for="(item, index) in optionsList"
              :key="index"
            >
              <!-- 过滤字段 -->
              <div class="left-div">
                <div class="page-title-div-select">
                  <a-select
                    style="width: 100%"
                    placeholder="请选择过滤字段"
                    v-model="item.ev"
                  >
                    <a-select-option
                      :value="e.name"
                      v-for="(e, eIndex) in fliterText"
                      :key="eIndex"
                    >
                      {{ e.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div class="page-title-div-img"></div>
              </div>
              <!-- 过滤条件 -->
              <div class="right-div">
                <div class="page-title-div-select">
                  <a-select
                    style="width: 100%"
                    placeholder="请选择过滤条件"
                    v-model="item.conditions"
                  >
                    <a-select-option
                      :value="dn.name"
                      v-for="dn in flitercConditions"
                      :key="dn.id"
                    >
                      {{ dn.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div class="page-title-div-img"></div>
              </div>
              <!--  -->
              <div class="options_input-div">
                <a-input
                  class="input_style"
                  placeholder="{ 请输入JS表达式 }"
                  v-show="item.codeStatus == 'code' "
                  v-model="item.code"
                />
                <a-input
                  v-model="item.code"
                  :prefix="prefix"
                  :suffix="suffix"
                  v-show="item.codeStatus == 'js' "
                  placeholder="请输入JS表达式"
                />
              </div>
              <!-- 控制图标 -->
              <div class="options_icon-div">
                <img
                  @click="changeImg(index)"
                  :src="item.codeStatus == 'code' ? jsImg : img_c"
                  style="margin-right: 10px"
                  alt=""
                />
                <img :src="emptyImg" alt="错误" @click="del(index)" />
              </div>
            </div>
            <div class="body_btn-div">
              <a-button
                class="options_btn"
                type="dashed"
                icon="plus"
                @click="addData"
              ></a-button>
            </div>
          </div>
        </div>
      </div>
      <div v-show="addVisible" class="dataBtn_group-div">
        <a-button
          class="okBtn"
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleOk"
        >
          确认提交
        </a-button>
        <a-button class="cancalBtn" key="back" @click="handleCancel">
          取消
        </a-button>
      </div>

      <!-- 编辑弹窗显示内容 -->
      <div v-show="editVisible" class="add_modal-main">
        <!-- header -->
        <div class="addModal_user-div">
          <!-- 新增用户 -->
          <div class="left-div">
            <a-input
              placeholder="新增用户"
              class="input_style"
              v-model="editData.userdata.name"
            />
          </div>
          <!-- 数据名选择 -->
          <div class="left-div">
            <div class="page-title-div-select">
              <a-select
                style="width: 100%"
                placeholder="请选择CRUD"
                v-model="editData.userdata.curd"
              >
                <a-select-option
                  :value="item"
                  v-for="(item, index) in 10"
                  :key="index"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </div>
            <div class="page-title-div-img"></div>
          </div>
          <!--  -->
          <div class="left-div">
            <div class="page-title-div-select">
              <a-select
                style="width: 100%"
                placeholder="请选择数据类型"
                v-model="editData.userdata.type"
              >
                <a-select-option
                  :value="item"
                  v-for="(item, index) in 10"
                  :key="index"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </div>
            <div class="page-title-div-img"></div>
          </div>

          <!-- 回调函数 -->
          <div class="left-div">
            <div class="page-title-div-select">
              <a-select
                style="width: 100%"
                placeholder="请选择回调函数"
                v-model="userData.type"
              >
                <a-select-option
                  :value="item"
                  v-for="(item, index) in 10"
                  :key="index"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </div>
            <div class="page-title-div-img"></div>
          </div>

          <!-- 控制图标 -->
          <div class="icon-div">
            <img :src="jsImg" alt="错误" @click="clickJSImg()" />
          </div>
        </div>
        <!-- options -->
        <div class="addModal_options-div">
          <!-- 标题 -->
          <p class="rightData_title-p">字段配置</p>
          <div class="options_body-div">
            <div
              class="options_bodyContainer-div"
              v-for="(item, index) in editData.info"
              :key="index"
            >
              <!-- 过滤字段 -->
              <div class="left-div">
                <div class="page-title-div-select">
                  <a-select
                    style="width: 100%"
                    placeholder="请选择过滤字段"
                    v-model="item.ev"
                  >
                    <a-select-option
                      :value="e.name"
                      v-for="(e, eIndex) in fliterText"
                      :key="eIndex"
                    >
                      {{ e.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div class="page-title-div-img"></div>
              </div>
              <!-- 过滤条件 -->
              <div class="right-div">
                <div class="page-title-div-select">
                  <a-select
                    style="width: 100%"
                    placeholder="请选择过滤条件"
                    v-model="item.conditions"
                  >
                    <a-select-option
                      :value="dn.name"
                      v-for="dn in flitercConditions"
                      :key="dn.id"
                    >
                      {{ dn.name }}
                    </a-select-option>
                  </a-select>
                </div>
                <div class="page-title-div-img"></div>
              </div>
              <!--  -->
              <div class="options_input-div">
                <a-input
                  class="input_style"
                  placeholder="{ 请输入JS表达式 }"
                  v-model="item.code"
                />
              </div>
              <!-- 控制图标 -->
              <div class="options_icon-div">
                <img :src="emptyImg" alt="错误" @click="editToDel(index)" />
              </div>
            </div>
            <div class="body_btn-div">
              <a-button
                class="options_btn"
                type="dashed"
                icon="plus"
                @click="editToAdd"
              ></a-button>
            </div>
          </div>
        </div>
      </div>
      <div v-show="editVisible" class="dataBtn_group-div">
        <a-button
          class="okBtn"
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleOk"
        >
          确认提交
        </a-button>
        <a-button class="cancalBtn" key="back" @click="handleCancel">
          取消
        </a-button>
      </div>
    </a-modal>
    <a-drawer
      placement="right"
      :closable="false"
      :visible="showCodeDrawer"
      @close="onCloseShowCodeDrawer"
    >
      <div class="codemirror">
        <codemirror v-model="code" :options="cmOption" class="code-mirror">
        </codemirror>
        <div class="bottom_button">
          <a-button
            type="primary"
            style="margin-right: 20px"
            @click="onCloseShowCodeDrawer()"
            >确认</a-button
          >
          <a-button type="danger" @click="onCloseShowCodeDrawer()"
            >取消</a-button
          >
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";
import BlockComponent from "@/utils/BlockComponent.js";
import _ from "lodash";
export default {
  name: "RightData",
  props: {
    component: {
      type: Object,
      default: new BlockComponent(),
    },
  },
  components: {
    codemirror,
  },
  data() {
    return {
      note: {},
      emptyActiveImg: require("@/assets/edit-page/empty.png"),
      emptyImg: require("@/assets/edit-page/empty-d.png"),
      list: [
        {
          userdata: { name: "test" },
          info: [{}],
        },
      ],
      loading: false,
      addVisible: false,
      editVisible: false,
      editData: {
        info: [
          {
            id: undefined,
            ev: undefined,
            conditions: undefined,
            code: undefined,
          },
        ],
        userdata: {
          name: undefined,
          curd: undefined,
          type: undefined,
        },
      }, //编辑的数据
      fliterText: [
        {
          // v-for里套v-for ,注意重复key的问题
          id: 123301,
          name: "onClick",
        },
        {
          id: 123302,
          name: "onChange",
        },
      ],
      flitercConditions: [
        {
          id: 123303,
          name: "=",
        },
        {
          id: 123304,
          name: ">",
        },
        {
          id: 123305,
          name: "<",
        },
        {
          id: 123306,
          name: ">=",
        },
        {
          id: 123307,
          name: "<=",
        },
        {
          id: 123308,
          name: "包含",
        },
        {
          id: 123309,
          name: "不包含",
        },
        {
          id: 1231201,
          name: "不为空",
        },
        {
          id: 123213,
          name: "为空",
        },
      ],
      optionsList: [
        {
          id: undefined,
          ev: undefined,
          conditions: undefined,
          code: undefined,
          codeStatus:'code'
        },
      ],
      userData: {
        name: undefined,
        curd: undefined,
        type: undefined,
      },
      jsImg: require("@/assets/edit-page/js-c.png"),
      img_c: require("@/assets/edit-page/js.png"),
      showCodeDrawer: false,
      visible: false,
      code: "",
      cmOption: {
        tabSize: 2, // tab
        styleActiveLine: true, // 高亮选中行
        lineNumbers: true, // 显示行号
        styleSelectedText: true,
        line: true,
        foldGutter: true, // 块槽
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true }, // 可以启用该选项来突出显示当前选中的内容的所有实例
        mode: {
          // 模式, 可查看 codemirror/mode 中的所有模式
          name: "javascript",
          json: true,
        },
        // hint.js options
        hintOptions: {
          // 当匹配只有一项的时候是否自动补全
          completeSingle: false,
        },
        // 快捷键 可提供三种模式 sublime、emacs、vim
        keyMap: "sublime",
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: "base16-light", // 主题
        extraKeys: { Ctrl: "autocomplete" }, // 可以用于为编辑器指定额外的键绑定，以及keyMap定义的键绑定
      },
      prefix: "{{",
      suffix: "}}",
    };
  },
  watch: {
    component: {
      handler(component) {
        console.log(`数据面板监听到props component 变化: `, component.note);
        this.note = _.cloneDeep(component.note);
      },
      deep: true,
    },
  },
  methods: {
    setComponent() {
      bus.$emit("update-component-note", this.note);
    },
    handleOk() {
      console.log(this.userData, "userData", this.optionsList, "optionsList");
      this.loading = true;
      setTimeout(() => {
        this.addList(this.userData, this.optionsList);
        this.loading = false;
        this.handleCancel();
      }, 3000);
    },
    handleCancel() {
      this.visible = false;
      this.addVisible = false;
      this.editVisible = false;
      this.clearParams();
    },
    clearParams() {
      this.optionsList = [
        {
          id: undefined,
          ev: undefined,
          conditions: undefined,
          code: undefined,
        },
      ];
      this.userData = {
        name: undefined,
        curd: undefined,
        type: undefined,
      };
    },
    addList(userdata, info) {
      let obj = { userdata, info };
      this.list.push(obj);
    },
    remove(index) {
      this.list.splice(index, 1);
    },

    /**
     * @name 增加事件
     * @description 模拟数据添加
     */
    addData() {
      // this.optionsList+=1
      this.optionsList.push({
        id: Math.round(Math.random() * 9999991),
        ev: undefined,
        conditions: undefined,
        code: undefined,
        codeStatus: 'code',
      });
    },
    editToAdd() {
      this.editData.info.push({
        id: Math.round(Math.random() * 9999991),
        ev: undefined,
        conditions: undefined,
        code: undefined,
      });
    },
    editToDel(index) {
      this.editData.info.splice(index, 1);
    },
    del(index) {
      console.log("删除");
      this.optionsList.splice(index, 1);
    },
    editEvent(data) {
      this.visible = true;
      this.editData = data;
      this.editVisible = true;
      this.addVisible = false;
      console.log(this.editData, "editData");
    },
    clickJSImg() {
      this.showCodeDrawer = true;
    },
    onCloseShowCodeDrawer() {
      this.showCodeDrawer = false;
    },
    showAddModal() {
      this.visible = true;
      this.editVisible = false;
      this.addVisible = true;
    },
    changeImg(index) {
      this.optionsList = this.optionsList.map((item, idx) => {
        if (idx == index) {
          let codeStatus = item.codeStatus == "code" ? "js" : "code";
          return {
            ...item,
            codeStatus,
          };
        } else {
          return item;
        }
      });
      console.log("");
    },
  },
};
</script>

<style scoped>
@import url("./index.css");
</style>
